/*
 *  Copyright © Microsoft Corporation. All rights reserved.
 */

import { IBreadcrumbStyles } from '@fluentui/react/lib/Breadcrumb';
import { IStackItemStyles, IStackStyles, IStackTokens } from '@fluentui/react/lib/Stack';
import { ITheme } from '@fluentui/react/lib/Styling';

export const getStackStyles = (theme: ITheme): Partial<IStackStyles> => {
    return {
        root: {
            borderColor: theme.palette.neutralTertiaryAlt,
            borderStyle: 'solid',
            borderTopWidth: '1px',
            borderRightWidth: 0,
            borderBottomWidth: '1px',
            borderLeftWidth: 0,
            justifyContent: 'space-between',
            paddingLeft: '1.125rem',
            paddingRight: '1.25rem',
            paddingTop: '0.5rem',
            paddingBottom: '0.5rem',
        },
    };
};

export const getBreadcrumbStyles = (theme: ITheme): Partial<IBreadcrumbStyles> => {
    return {
        root: {
            selectors: {
                '.ms-Breadcrumb-item': {
                    color: theme.palette.black + ' !important',
                },
            },
            margin: 0,
            paddingLeft: 0,
        },
        itemLink: {
            color: theme.palette.black,
        },
    };
};

export const getInnerStackTokens = (): Partial<IStackTokens> => {
    return { childrenGap: '0.5rem' };
};

export const getStatusStyles = (theme: ITheme, isError: boolean): Partial<IStackItemStyles> => {
    return { root: { marginRight: '1.25rem', color: isError ? theme.palette.red : theme.palette.neutralDark } };
};
